const isOttoDomain = window.location.hostname === 'ottoinsurance.com';
export default isOttoDomain;
